/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WbsDto interface.
 */
export function instanceOfWbsDto(value) {
    return true;
}
export function WbsDtoFromJSON(json) {
    return WbsDtoFromJSONTyped(json, false);
}
export function WbsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'titolo': json['titolo'] == null ? undefined : json['titolo'],
        'pesoAttivita': json['pesoAttivita'] == null ? undefined : json['pesoAttivita'],
        'corrispettivoEconomico': json['corrispettivoEconomico'] == null ? undefined : json['corrispettivoEconomico'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
    };
}
export function WbsDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'titolo': value['titolo'],
        'pesoAttivita': value['pesoAttivita'],
        'corrispettivoEconomico': value['corrispettivoEconomico'],
        'projectId': value['projectId'],
    };
}
